<template lang="pug">
#map-splitter.absolute.absolute--fill
    #rightmap.absolute.absolute--fill
    #leftmap.absolute.absolute--fill

    .mapboxgl-ctrl-group.mapboxgl-ctrl#share-template(style="margin-top: 1em")
        button.mapbox-gl-ctrl-icon(@click="clickShare" style="background-image: url(./noun_Share_162946.png) !important; background-size: 2.5em; width:2.5em; height:2em;" title="Share map" aria-label="Share map")
</template>

<script>
import mapboxgl from 'mapbox-gl';
import Compare from 'mapbox-gl-compare';
// monkey-patch missing event fire
// see https://github.com/mapbox/mapbox-gl-compare/pull/35
Compare.prototype._onTouchEnd = function() {
    document.removeEventListener('touchmove', this._onMove);
    document.removeEventListener('touchend', this._onTouchEnd);
    this.fire('slideend', { currentPosition: this.currentPosition });
};
import U from 'mapbox-gl-utils';
import { EventBus } from '../EventBus';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import axios from 'axios';
import accentInsensitiveSearch from 'accent-insensitive-search';
let regionIndex = [];
const regionColors = {
    subregions: 'hsl(0, 58%, 50%)',
    mid /*regions*/: 'hsl(308, 68%, 31%)',
    top: 'hsl(22, 71%, 69%)',
};
const layers = {
    subregions: {
        lineId: 'Subregions',
        color: 'hsl(0, 58%, 50%)',
        fadeColor: 'hsl(0, 35%, 65%)',
        highlightColor: 'hsl(0, 68%, 50%)',
        labelId: 'm-sbrgn-labels-afx25k',
    },
    mid: {
        lineId: 'Regions copy',
        fillId: 'Regions',
        labelId: 'lbls-middle-764v5m',
        color: 'hsl(308, 68%, 31%)',
        highlightColor: 'hsl(308, 78%, 23%)',
        fadeColor: 'hsl(308, 50%, 60%)',
    },
    top: {
        lineId: 'master-top copy',
        fillId: 'master-top',
        labelId: 'm-top-labels-9isyyt',
        color: 'hsl(22, 71%, 69%)',
        highlightColor: 'hsl(11, 81%, 50%)',
        fadeColor: 'hsl(22, 50%, 80%)',
    },
};

import classAbbreviations from './classCodes';

const regionLineLayers = ['master-top copy', 'Regions copy', 'Subregions'];
const regionLineHitLayers = regionLineLayers.map((l) => `${l} hit`);
const regionFillLayers = ['master-top', 'Regions']; // no subregions?

function makeHighlightLayers(map) {
    console.log('running');
    for (const layer of Object.values(layers)) {
        map.addLayer({
            ...map.U.getLayerStyle(layer.lineId),
            paint: {
                'line-color': 'transparent',
                'line-width': 15,
            },
            layout: {
                'line-cap': 'round',
            },
            id: `${layer.lineId} hit`,
            filter: true,
        });
        map.addLayer({
            ...map.U.getLayerStyle(layer.lineId),
            id: `${layer.lineId} highlight`,
            filter: false,
        });
        map.U.setLineColor(`${layer.lineId} highlight`, layer.highlightColor);
        map.addLayer({
            ...map.U.getLayerStyle(layer.labelId),
            id: `${layer.labelId} highlight`,
            filter: false,
        });
        map.U.setTextColor(`${layer.labelId} highlight`, layer.highlightColor);
        if (layer.fillId) {
            map.addLayer({
                ...map.U.getLayerStyle(layer.fillId),
                id: `${layer.fillId} highlight`,
                filter: false,
            });
        }
    }
}

function makeSatelliteMap(map) {
    for (const layer of map.getStyle().layers) {
        if (!(layer['source-layer'] || '').match(/_(top|middle|sbrgns)/)) {
            map.U.hide(layer.id);
        }
    }
    map.U.show('mapbox-satellite');
    map.U.setRasterOpacity('mapbox-satellite', 1);
}

function loadIndex() {
    return Promise.all([
        axios.get('top-labels.geojson'),
        axios.get('mid-labels.geojson'),
        axios.get('subregion-labels.geojson'),
    ]).then(
        ([
            { data: topLabels },
            { data: midLabels },
            { data: subregionLabels },
        ]) => {
            regionIndex = [
                ...topLabels.features.map((f) => ({
                    ...f,
                    source: 'topLabels',
                })),
                ...midLabels.features.map((f) => ({
                    ...f,
                    source: 'midLabels',
                })),
                ...subregionLabels.features.map((f) => ({
                    ...f,
                    source: 'subregionLabels',
                })),
            ];
        }
    );
}
function queryIndex(query) {
    function score({ properties: p }) {
        // function idx(field = '') {
        //     return (field || '').toLowerCase().indexOf(query.toLowerCase());
        // }
        function contains(field, atStart = false) {
            try {
                return accentInsensitiveSearch(
                    query.toLowerCase(),
                    (field || '').toLowerCase()
                    // { startWith: atStart }
                );
            } catch (e) {
                return (
                    query.toLowerCase().indexOf((field || '').toLowerCase()) >=
                    0
                );
            }
        }

        let score = 0;
        if (contains(p.Name_rgn)) {
            score += 10;
        } else if (contains(p.Name_rgn, true)) {
            score += 5;
        }
        if (contains(p.altname)) {
            score += 8;
        } else if (contains(p.altname, true)) {
            score += 4;
        }
        return score;
    }
    const results = regionIndex.filter((f) => score(f) > 0).map((f, i) => ({
        place_name: f.properties.Name_rgn,
        center: f.geometry.coordinates,
        place_type: 'place', //'region',
        text: f.properties.Name_rgn,
        id: i,
        geometry: f.geometry,
        properties: {
            ...f.properties,
            score: score(f),
            source: f.source,
        },
        source: f.source,
    }));
    return results;
    // console.log(results);
}

function highlightRegion(props) {
    function coloriseLayer(layer, color) {
        if (layer.fillId) {
            window.leftmap.U.setFillColor(layer.fillId, color); // was both
        }
        window.leftmap.U.setLineColor(layer.lineId, color); // was both
        window.leftmap.U.setTextColor(layer.labelId, color); // was both
    }
    const fade = !!props;

    const highlightFilter = !props
        ? false
        : [
              'all',
              ['==', ['to-string', ['get', 'country']], props.country || ''],
              ['==', ['to-string', ['get', 'class']], props.class || ''],
              ['==', ['to-string', ['get', 'Name_rgn']], props.Name_rgn || ''],
          ];
    for (let layer of Object.values(layers)) {
        coloriseLayer(layer, fade ? layer.fadeColor : layer.color);
        window.leftmap.U.setFilter(
            [`${layer.lineId} highlight`, `${layer.labelId} highlight`],
            highlightFilter
        );
        if (layer.fillId) {
            window.leftmap.U.setFilter(
                `${layer.fillId} highlight`,
                highlightFilter
            );
        }
    }
}

function selectRegion(feature) {
    EventBus.$emit('select-feature', feature);
    highlightRegion(feature ? feature.properties : null);
}

function zoomToRegionGroup(feature) {
    const bbox = feature.properties._bbox;
    window.leftmap.fitBounds(
        bbox,
        {
            padding: { top: 50, left: 50, right: 50, bottom: 50 },
        },
        {
            moveSource: 'zoomToRegionGroup',
        }
    );
    if (window.geocoder.mapMarker) {
        window.geocoder.mapMarker.remove();
    }
}

function zoomToSingleRegion(feature) {
    const bbox = indexForRegion(feature).properties._bbox;
    window.leftmap.fitBounds(bbox, {
        padding: { top: 50, left: 50, right: 50, bottom: 50 },
    });
    if (window.geocoder.mapMarker) {
        window.geocoder.mapMarker.remove();
    }
}

function bothMaps(func, ...args) {
    window.leftmap[func](...args);
    if (window.rightmap) {
        window.rightmap[func](...args);
    }
}

function bothMapsU(func, ...args) {
    window.leftmap.U[func](...args);
    if (window.rightmap) {
        window.rightmap.U[func](...args);
    }
}

function indexForRegion(regionFeature) {
    const rf = regionFeature.properties;
    const idx = regionIndex.find(
        (f) =>
            f.properties.Name_rgn === rf.Name_rgn &&
            f.properties.class === rf.class
    );
    if (!idx) {
        console.log(
            `Couldn't find index for region: Name_rgn ${rf.Name_rgn}, class: ${
                rf.class
            }`
        );
    }
    return idx;
}

// function zoomForRegion(regionFeature) {
//     const idx = regionIndex.find(
//         (f) =>
//             f.properties.Name_rgn === regionFeature.properties.Name_rgn &&
//             f.properties.class === regionFeature.properties.class
//     );
//     return idx.tippecanoe.minzoom + 4;
// }

function blurGeocoder() {
    window.setTimeout(
        () =>
            document
                .getElementsByClassName('mapboxgl-ctrl-geocoder--input')[0]
                .blur(),
        1
    );
}

export default {
    async mounted() {
        function clearGeocoder() {
            geocoder.setInput('');

            /*
            // to prevent keyboard popping up
            document
                .querySelector('.mapboxgl-ctrl-geocoder--input')
                .setAttribute('readonly', true);
            try {
                geocoder.clear();

                blurGeocoder();
            } finally {
                document
                    .querySelector('.mapboxgl-ctrl-geocoder--input')
                    .removeAttribute('readonly');
            }
            */

            if (geocoder.mapMarker) {
                geocoder.mapMarker.remove();
            }
        }
        const viewProvided = window.location.hash.match(/view=/);

        mapboxgl.accessToken =
            'pk.eyJ1IjoibWFydGludm9ud3lzcyIsImEiOiJ5UDZqNzlRIn0.C2v_MaFow7-hiueBnq2ELQ';
        const europeBounds = [[-6.797, 39.5577], [42.392, 56.49]];
        const leftmap = new mapboxgl.Map({
            container: 'leftmap',
            bounds: europeBounds,
            style: 'mapbox://styles/martinvonwyss/cjwjyc3tt096t1cpnqku9h00z',
            // touchPitch: false,
            // dragRotate: false,
            hash: 'view',
        });
        U.init(leftmap, mapboxgl);
        const splitterMode =
            window.location.hash.match(/splitter=(\w+)/) &&
            window.location.hash.match(/splitter=(\w+)/)[1];
        const rightMode = window.location.hash.match(/choro/)
            ? 'choro'
            : 'satellite';
        let rightmap, splitter;
        if (splitterMode) {
            rightmap = new mapboxgl.Map({
                container: 'rightmap',
                // center: [140, -30],
                // zoom: 4,
                bounds: europeBounds,
                style: {
                    choro:
                        'mapbox://styles/martinvonwyss/cka4uhw590hhu1io7l5wld1ip',
                    satellite:
                        'mapbox://styles/martinvonwyss/cjwjyc3tt096t1cpnqku9h00z',
                }[splitterMode],
                hash: 'view',
            });
            splitter = new Compare(leftmap, rightmap, '#map-splitter', {});
            window.splitter = splitter;
            splitter.setSlider(
                0.8 *
                    document.getElementById('map-splitter').getClientRects()[0]
                        .width
            );
            splitter.on('slideend', () => {
                const maxPos =
                    leftmap.getContainer().getClientRects()[0].width - 30;
                if (splitter.currentPosition < 30) {
                    splitter.setSlider(30);
                } else if (splitter.currentPosition > maxPos) {
                    splitter.setSlider(maxPos);
                }
            });

            U.init(rightmap, mapboxgl);
        }
        window.map = leftmap;
        window.leftmap = leftmap;
        window.rightmap = rightmap;
        window.app.Map = this;
        if (splitterMode === 'satellite') {
            rightmap.U.onLoad(() => makeSatelliteMap(rightmap));
        }
        map = leftmap;
        bothMaps('addControl', new mapboxgl.NavigationControl(), 'top-right');
        bothMaps('on', 'move', () => (window.app.App.shareOpen = false));
        bothMaps('on', 'click', () => (window.app.App.shareOpen = false));
        leftmap.U.onLoad(() => {
            makeHighlightLayers(window.leftmap);
        });
        leftmap.once('move', () => {
            if (!viewProvided) {
                bothMaps('fitBounds', europeBounds, { animate: false });
            }
        });
        bothMaps(
            'addControl',
            {
                onAdd: (map) => {
                    return document.querySelector('#share-template');
                },
            },
            'top-right'
        );
        if (rightmap) {
            rightmap.U.onLoad(() => makeHighlightLayers(window.rightmap));
        }
        await loadIndex();
        const geocoder = new MapboxGeocoder({
            accessToken: mapboxgl.accessToken,
            mapboxgl: mapboxgl,
            localGeocoder: queryIndex,
            localGeocoderOnly: window.location.hash.match(/dev/),
            zoom: 8,
            clearAndBlurOnEsc: true,
            types: 'country,region,district,place,locality',
            limit: 8,
            render: (item) => {
                if (!item.source) {
                    return item.place_name;
                }
                const p = item.properties;
                const classClass = item.source || '';
                let out = `<span class="${classClass} region-title">${p.Name_rgn +
                    (p.altname ? ' (' + p.altname + ')' : '')}</span>`;
                if (p.class) {
                    out += `, <span class="class-field ${classClass}">${classAbbreviations[
                        p.class
                    ] || p.class}</span>`;
                }
                if (p.country) {
                    out += `, <span class="state-country ${classClass}">${
                        p.state ? p.state + ', ' : ''
                    }${p.country}</span>`;
                }
                return out;
            },
        });
        window.geocoder = geocoder;
        geocoder.on('result', ({ result }) => {
            console.log(result);
            if (result.source) {
                selectRegion(result);
            } else {
                selectRegion();
            }
            if (result.properties._bbox) {
                zoomToRegionGroup(result);
            }
            blurGeocoder();
        });

        geocoder.on('loading', () => EventBus.$emit('select-feature'));

        // leftmap.addControl(geocoder, 'top-left');
        document
            .getElementById('geocoder-container')
            .appendChild(geocoder.onAdd(leftmap));
        document
            .querySelector('.mapboxgl-ctrl-geocoder--input')
            .addEventListener('focus', () => {
                geocoder.clear();
            });
        document.getElementsByClassName(
            'mapboxgl-ctrl-geocoder--input'
        )[0].placeholder =
            'Search for a wine region, town, nation';

        const interactiveLayers = [
            ...regionLineLayers,
            ...regionLineHitLayers,
            ...Object.values(layers).map((l) => l.labelId),
            ...Object.values(layers).map((l) => l.labelId + ' highlight'),
            ...Object.values(layers).map((l) => l.lineId + ' highlight'),
        ];
        bothMapsU('hoverPointer', interactiveLayers);
        bothMapsU(
            'clickOneLayer',
            interactiveLayers,
            (e) => {
                selectRegion(e.features[0]);
                zoomToSingleRegion(e.features[0]);
                clearGeocoder();
            },
            (e) => {
                selectRegion(null);
                clearGeocoder();
            }
        );
        bothMaps('on', 'dragstart', () => {
            selectRegion(null);
            clearGeocoder();
        });
        bothMaps('on', 'wheel', (e) => {
            clearGeocoder();
        });
        EventBus.$on('clear-feature', () => selectRegion());
    },
    methods: {
        clickShare() {
            window.app.App.shareOpen = !window.app.App.shareOpen;
        },
    },
};
import 'mapbox-gl/dist/mapbox-gl.css';
import 'mapbox-gl-compare/dist/mapbox-gl-compare.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
</script>

<style>
.topLabels,
.midLabels,
.subregionLabels {
    /* font-weight: bold; */
    color: hsl(340, 80%, 30%);
}

.region-title {
    font-weight: bold;
    font-size: unset;
}
/* .topLabels {
    color: hsl(22, 71%, 69%);
}

.midLabels {
    color: hsl(308, 68%, 31%);
}

.subregionLabels {
    color: hsl(0, 58%, 50%);
} */

.class-field {
    /* font-size: 80%; */
    font-style: italic;
}

.state-country {
    /* font-size: 80%; */
    font-weight: normal;
}

.mapboxgl-ctrl-geocoder {
    /* font-size: 32px !important; */
    /* max-width: 340px !important; */
    width: 340px;
    font-family: 'DIN';
}
.mapboxgl-ctrl-geocoder--input {
    /* padding-top: 24px; */
    /* padding-bottom: 24px; */
}

.mapboxgl-compare {
    z-index: 0;
}

.mapboxgl-compare .compare-swiper-vertical {
    /* Remember to update this for whatever final URL */
    background-image: url(../assets/climate-zones.png) !important;
    background-size: cover;
}

.share-button {
    background: white;
    /* border: 1px solid grey; */
    width: 3em;
    height: 2em;
    /* background-size: cover; */
    background-size: 2.5em;
    /* background-image: url(../assets/noun_Share_162946.png) !important; */
    background-image: url(/public/noun_Share_162946.png) !important;
    /* background-image: url(https://mapswell.site44.com/images/wwr/noun_Share_162946.svg) !important; */
}
.share-group {
    margin-top: 1em;
}
</style>
